import { createContext, useContext, useEffect, useState } from "react";
import ClientService from "services/client.service";
import { AuthContext } from "context";

export const ClientContext = createContext();

export const ClientProvider = ({ children }) => {
  const { user } = useContext(AuthContext);
  // Clientes é Premium: para free a API responde 403 premium_required (abriria o modal no login)
  const isPremium = Boolean(user?.is_premium);
  const [clients, setClients] = useState([]);
  const [loading, setLoading] = useState(false);

  /**
   * Carrega todos os clientes
   */
  const loadClients = async () => {
    setLoading(true);
    try {
      const response = await ClientService.getClients();
      setClients(response || []);
    } catch (error) {
      console.error("Erro ao carregar clientes:", error);
    } finally {
      setLoading(false);
    }
  };

  /**
   * Cria cliente e atualiza lista
   */
  const createClient = async (payload) => {
    const client = await ClientService.createClient(payload);
    setClients((prev) => [...prev, client]);
    return client;
  };

  /**
   * Atualiza cliente
   */
  const updateClient = async (id, data) => {
    const response = await ClientService.update(id, data);

    setClients((prev) =>
      prev.map((c) => (c.id === id ? response.data : c))
    );

    return response.data;
};

  /**
   * Remove cliente
   */
  const deleteClient = async (id) => {
    await ClientService.deleteClient(id);
    setClients((prev) => prev.filter((c) => c.id !== id));
  };

  useEffect(() => {
    if (isPremium) loadClients();
  }, [isPremium]);

  return (
    <ClientContext.Provider
      value={{
        clients,
        loading,
        loadClients,
        createClient,
        updateClient,
        deleteClient,
      }}
    >
      {children}
    </ClientContext.Provider>
  );
};
